'use client';

import { type LayoutNode } from 'shop-ui/types/basic';
import { ELEMENT_TYPE, FEATURE_FLAG_KEYS } from 'shop-ui/constants';
import { getElementUlId } from 'app/shop-ui/tools/getElementUlId';
import { combineComponent } from 'shop-ui/tools/combineComponent';
import { GRID_LAYOUT_TYPE } from 'shop-ui/section/Grid/rules';
import i18n from '@shared/i18n';

export const componentName = 'Divider';

export enum OFFICIAL_DIVIDER_KEY {
    DIVIDER = 'official-divider',
}

export const showCutList = [
    {
        key: OFFICIAL_DIVIDER_KEY.DIVIDER,
        type: ELEMENT_TYPE.DIVIDER,
        content: i18n.gettext('分隔線'),
    },
];

const config: LayoutNode = {
    id: '',
    type: ELEMENT_TYPE.DIVIDER,
    name: componentName,
    enable: true, // 通常要開啟
    next: null,
    deletable: true, // 通常要開啟
};

export const features = [
    FEATURE_FLAG_KEYS.RESIZE_HANDLE,
    FEATURE_FLAG_KEYS.BORDER_STYLE,
    FEATURE_FLAG_KEYS.COLOR,
    FEATURE_FLAG_KEYS.BORDER_WIDTH,
    FEATURE_FLAG_KEYS.PADDING_X,
    FEATURE_FLAG_KEYS.PADDING_Y,
    FEATURE_FLAG_KEYS.ANIMATION,
];

const defaultStyle = {
    [FEATURE_FLAG_KEYS.BORDER_STYLE]: 'solid',
    [FEATURE_FLAG_KEYS.COLOR]: 'rgba(211, 211, 213, 1)',
    [FEATURE_FLAG_KEYS.BORDER_WIDTH]: '1px',
    [FEATURE_FLAG_KEYS.PADDING_X]: '10px',
    [FEATURE_FLAG_KEYS.PADDING_Y]: '10px',
} as const;

export function createDivider(name: string) {
    const id = getElementUlId();

    const layout = {
        ...config,
        name: name || config.name,
        id,
    };

    return {
        id,
        layout,
        style: {
            ...defaultStyle,
        },
    };
}

export function generate(
    sectionName: string = i18n.gettext('區塊'),
    name: string = OFFICIAL_DIVIDER_KEY.DIVIDER,
    options?: { shouldWrap?: boolean }
) {
    const Divider = createDivider(name);

    const shouldWrap = options?.shouldWrap ?? true;

    return combineComponent(sectionName, [Divider], {
        primaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
        secondaryGridType: GRID_LAYOUT_TYPE.SINGLE_CELL,
        shouldWrap,
    });
}
